import React from "react"

import { ChatBubbleLeftIcon } from "@heroicons/react/24/outline"

import LocalTime from "components/LocalTime"
import Avatar from "components/Messaging/Avatar"

type UserType = {
  id: string
  type: "Teacher" | "Student" | "Tutor" | "Parent"
  messagingDisplayName: string
  showPath: string
  avatar: {
    thumbUrl: string
  }
}

export type Thread = {
  id: string
  title: string
  showPath: string
  messagesCount: number
  users: UserType[]
  lastMessage?: {
    id: string
    read: boolean
    content: string
    createdAt: string
    author: UserType
  }
}

export type ListProps = {
  threads: Thread[]
  viewerId: string
}

const ThreadsList: React.FC<ListProps> = ({ threads, viewerId }) => {
  return (
    <ul className="">
      {threads.map(thread => (
        <li
          role="presentation"
          onClick={() => (window.location.href = thread.showPath)}
          key={thread.id}
          className="flex cursor-pointer flex-wrap items-center justify-between gap-x-6 gap-y-4 border-0 border-b-2 border-solid border-b-slate-300/50 py-5 hover:bg-gray-100 sm:flex-nowrap sm:px-2"
        >
          <div>
            <p className="text-sm/6 font-semibold text-gray-900">
              <a href={thread.showPath} className="hover:underline">
                {thread.title}
              </a>
            </p>

            {thread.lastMessage && (
              <>
                <div className={thread.lastMessage.read ? "" : "font-bold"}>
                  {thread.lastMessage.content}
                </div>
                <div className="text-xs/5 mt-1 flex items-center gap-x-2 text-gray-500">
                  <>
                    <p>
                      {thread.lastMessage.author.id === viewerId
                        ? "You"
                        : thread.lastMessage.author.messagingDisplayName}
                    </p>
                    <p>
                      <LocalTime
                        timestamp={thread.lastMessage.createdAt}
                        relative
                      />
                    </p>
                  </>
                </div>
              </>
            )}
          </div>

          <dl className="flex w-full flex-none justify-between gap-x-8 sm:w-auto">
            <div className="flex -space-x-0.5">
              <dt className="sr-only">Members</dt>
              {thread.users.map(user => (
                <dd key={user.id}>
                  <Avatar
                    alt={user.messagingDisplayName}
                    src={user.avatar.thumbUrl}
                  />
                </dd>
              ))}
            </div>
            <div className="flex h-16 gap-x-2.5">
              <dt className="">
                <span className="sr-only">Total messages</span>
                <ChatBubbleLeftIcon
                  aria-hidden="true"
                  className="h-8 text-gray-400"
                />
              </dt>
              <dd className="text-sm/6 m-0 text-gray-900">
                {thread.messagesCount}
              </dd>
            </div>
          </dl>
        </li>
      ))}
    </ul>
  )
}

export default ThreadsList
